import { render, staticRenderFns } from "./ContentViewer.vue?vue&type=template&id=05dac71a"
import script from "./ContentViewer.vue?vue&type=script&lang=js"
export * from "./ContentViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports